import type { ConversationEventDetails, ConversationTurnEntry, Timestamp, UUID } from '@/index'
import type { Command } from './Command'

export interface ConversationTurn {
  userPromptId: UUID
  startTime: Timestamp
  endTime: Timestamp | null
  events: ConversationTurnEntry[]
  userCommands: Command[]
}

export function conversationTurnFrom(
  conversationEvent: ConversationEventDetails,
): ConversationTurn {
  return {
    userPromptId: conversationEvent.eventMetadata.userPromptId,
    startTime: conversationEvent.eventMetadata.timestamp,
    endTime: null,
    events: [],
    userCommands: [],
  }
}
